export class ForgotPasswordRequest {
  email: string;

  constructor(email: string) {
    this.email = email;
  }
}
